<template>
  <v-container v-resize="fitBorders">
    <ConfirmDialog
      :is-open.sync="dialogs.image.isOpened"
      dialog-max-width="80vw"
      :show-confirm-button="false"
    >
      <template v-slot:title>
        ID:  {{ getDialogData('image', 'image.id') }},
        {{`${getDialogData('image', 'image.width')}
        x ${getDialogData('image', 'image.height')}`}}
      </template>
      <template v-slot:body>
        <div class="image-wrapper">
          <img
            ref="dialogImage"
            alt=""
            :src="getDialogData('image', 'image.public_link')"
            @load="onImageLoad"
          />
          <div
            ref="dialogImageVerticalBorder"
            class="border-vertical"
          />
          <div
            ref="dialogImageHorizontalBorder"
            class="border-horizontal"
          />
        </div>
      </template>
    </ConfirmDialog>
  </v-container>
</template>

<script>

import ConfirmDialog from '@/components/dialogs/ConfirmDialog.vue';
import manageDialogsMixin from '../../mixins/manageDialogsMixin';

export default {
  name: 'ImageWithBorderDialog',
  components: { ConfirmDialog },
  mixins: [
    manageDialogsMixin,
  ],
  props: {
  },
  data() {
    return {
      dialogs: {
        image: {
          isOpened: false,
          data: {
            image: {},
          },
          defaults: {
            image: {},
          },
        },
      },
    };
  },

  methods: {
    onImageLoad() {
      this.fitBorders();
    },

    fitBorders() {
      this.$nextTick(async () => {
        await this.waitRef('dialogImage');
        await this.waitRef('dialogImageVerticalBorder', 'style');
        await this.waitRef('dialogImageHorizontalBorder', 'style');

        // eslint-disable-next-line max-len
        this.$refs.dialogImageVerticalBorder.style.maxWidth = `${this.$refs.dialogImage.width}px`;
        this.$refs.dialogImageVerticalBorder.style.width = `${this.$refs.dialogImage.height * 1.33}px`;
        this.$refs.dialogImageVerticalBorder.style.height = `${this.$refs.dialogImage.height}px`;
        // eslint-disable-next-line max-len
        this.$refs.dialogImageHorizontalBorder.style.height = `${this.$refs.dialogImage.width / 2.4}px`;
        this.$refs.dialogImageHorizontalBorder.style.width = `${this.$refs.dialogImage.width}px`;
        this.$refs.dialogImageHorizontalBorder.style.left = `${this.$refs.dialogImage.offsetLeft}px`;
      });
    },

    waitRef(ref, option = null) {
      return new Promise((resolve) => {
        const interval = setInterval(() => {
          // eslint-disable-next-line max-len
          if (this.$refs[ref] !== undefined && (option === null || this.$refs[ref][option] !== undefined)) {
            clearInterval(interval);
            resolve();
          }
        }, 50);
      });
    },
  },
};

</script>
<style scoped>
.image-wrapper {
  position: relative;
  height: 100%;
  width: 100%;
}

.image-wrapper img {
  display: block;
  margin: 0 auto;
  max-width: 70vw;
  max-height: 60vh;
  box-sizing: content-box;
}

.border-vertical, .border-horizontal {
  outline: 2px dashed red;
  pointer-events: none;
  z-index: 2;
  position: absolute;
}

.border-vertical {
  top: 0;
  bottom: 0;
  left: 50%;
  transform: translate(-50%, 0);
}
.border-horizontal {
  left: 0;
  right: 0;
  top: 50%;
  transform: translate(0,-50%);
}
</style>
